<template>

    <div>
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="{name:child.route}">
                        {{ child.name }}
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view></router-view>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import MenuItem from "../../Libraries/MenuItem";
import FixedTabs from "../../Libraries/FixedTabs";

export default {

    computed: {
        ...mapGetters([
            'can',
        ]),

        getMenu() {
            return [
                new MenuItem('Contacten', 'crm.contacts.index'),
                new MenuItem('Bedrijven', 'crm.companies.index'),
                new MenuItem('Collega\'s', 'crm.office.index'),
                new MenuItem('Groepen', 'crm.groups.index'),
            ];
        },
    },

    destroyed(){
        FixedTabs.unset();
    },

    methods: {
        isActiveChildRoute(child) {
            if (child.route === 'crm.contacts.index'
                && this.$route.name.split('.')[1] == 'contacts'
            ) {
                return true;
            }

            if (child.route === 'crm.companies.index'
                && this.$route.name.split('.')[1] == 'companies'
            ) {
                return true;
            }

            return child.route === this.$route.name;
        },
    },

    mounted(){
        FixedTabs.set();
    },

    name:'CrmLayout',

}

</script>
